import * as React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import HotelCarousel from "./hotelCarousel";
import { Trans } from "../utils/lang"

const TourAcommodation = ({ blok }) => {
  // console.log(blok)

  const TourAcommodationItem = ({items}) => {
    const it = items?.[0];
    return (
      <div className="overflow-x-hidden" key={it._uid} {...storyblokEditable(it)}>
        <div className="flex justify-center gap-5">
          {items.map((item, index)=>(
            <img key={`${it._uid}-${index}`} loading="lazy" src={`/icons/day${item.dayNumber}-number-only.svg`} alt={item.dayNumber} />
          ))}
        </div>
      <HotelCarousel blok={it.hotelCarousel} />
      <div className="py-5 text-center">
        <h4 className=""><span className="px-2">{it.hotelLocation}</span></h4>
        <h3 className="text-lg font-serif">{it.hotelName}</h3>
      </div>
      <div className="px-5" dangerouslySetInnerHTML={{ __html: renderRichText(it.hotelDescription) }}></div>
      <div className="pt-5 px-5 text-sm text-red-500" dangerouslySetInnerHTML={{ __html: renderRichText(it.hotelNotes) }}></div>
      </div>
    )
  };

  const groupAdjacentByHotelLocation = (itinerary) => {
    const grouped = [];
    let currentGroup = null;

    itinerary.forEach((it) => {
      if (it.hotelLocation) {
        if (
          currentGroup &&
          (currentGroup[0].hotelLocation === it.hotelLocation || currentGroup[0].hotelName === it.hotelName)
        ) {
          currentGroup.push(it);
        } else {
          if (currentGroup) {
            grouped.push(currentGroup);
          }
          currentGroup = [it];
        }
      }
    });

    if (currentGroup) {
      grouped.push(currentGroup);
    }

    return grouped;
  };

  const groupedItinerary = groupAdjacentByHotelLocation(blok.itinerary?.filter((it) => (it.hotelName || it.hotelLocation)) || []);

  return (
    <div id="accomodations" className="pt-6 pb-2"
      style={{backgroundColor: `${blok.accommodationBgColor?.color}`}}>

      <div className="container max-w-[700px] mx-auto py-10 text-center">
        <h2 className="text-3xl font-bold">{Trans('accommodations')}</h2>
        <div className="py-5 text-center" dangerouslySetInnerHTML={{ __html: renderRichText(blok.accommodationDescription) }}></div>
      </div>
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">        
        {groupedItinerary.map((group, groupIndex) => (
          <TourAcommodationItem
            key={groupIndex}
            items={group}
          />
        ))}
      </div>
    </div>
  )
};

export default TourAcommodation;
